'use client';

import { useEffect, useState } from 'react';
import CloseIcon from "components/Icons/CloseIcon";
import ErrorIcon from "components/Icons/ErrorIcon";
import InfoIcon from "components/Icons/InfoIcon";
import SuccessIcon from "components/Icons/SuccessIcon";
import WarningIcon from "components/Icons/WarningIcon";
import 'styles/scss/toast.scss';

const Icons = {
  info: <InfoIcon />,
  success: <SuccessIcon />,
  warning: <WarningIcon />,
  error: <ErrorIcon />,
  close: <CloseIcon />,
};

const toastTypes = {
  info: { className: 'toast-info', icon: Icons.info, title: "Información" },
  success: { className: 'toast-success', icon: Icons.success, title:"Correcto" },
  warning: { className: 'toast-warning', icon: Icons.warning, title:"Advertencia" },
  error: { className: 'toast-error', icon: Icons.error, title:"Ocurrió un error" },
};

export default function Toast({ message, type = 'info', onClose, hidden = ''}) {
  if (!message) return null;
  const { icon, className, title } = toastTypes[type];

  return (
      <div className={`toast ${className} ${hidden}`}>
        <div className="toast-icon">{icon}</div>
        <div className="toast-content">
          <span className="toast-title">{title}</span>
          <span className="toast-message">{message}</span>
        </div>
        <button type="button" onClick={onClose} className="toast-close">
          <CloseIcon />
        </button>
      </div>
  );
}

export function triggerToast(message, type = 'info') {
  const event = new CustomEvent('showToast', { detail: { message, type } });
  window.dispatchEvent(event);
}

export function ToastContainer() {
  const [toast, setToast] = useState({ message: '', type: 'info' });
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const handleShowToast = (event) => {
      setToast(event.detail);
      setIsHidden(false); // Muestra el toast inmediatamente
      setTimeout(() => {
            setIsHidden(true);
          },4000);
    };

    window.addEventListener('showToast', handleShowToast);
    return () => window.removeEventListener('showToast', handleShowToast);
  }, []);

  return <Toast message={toast.message}
                type={toast.type}
                onClose={() => {setIsHidden(true) }}
                hidden={isHidden ? 'toast-hidden' : ''} />;
}